/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDescriptionAbout_item = {
    readonly description: string | null;
    readonly " $refType": "PdpSharedDescriptionAbout_item";
};
export type PdpSharedDescriptionAbout_item$data = PdpSharedDescriptionAbout_item;
export type PdpSharedDescriptionAbout_item$key = {
    readonly " $data"?: PdpSharedDescriptionAbout_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAbout_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAbout_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'ed3271751e053046a4e75ed8dc8161f3';
export default node;
